import React, { useState } from 'react';

/**
 * Safe avatar with text-initials fallback when the image fails to load.
 *
 * Note (07/02/2026 review) : this component is intentionally JSX-only —
 * it never injects raw HTML. The fallback label is rendered as a text
 * node escaped by React. Driver names with markup-like characters are
 * therefore safe to display.
 */
export default function AvatarWithFallback({
  src,
  alt,
  fallback,            // string — short label to display when src fails (initials)
  className = '',
  fallbackClassName = 'bg-ink-700 text-slate-400 text-sm font-bold',
  testId,
}) {
  const [broken, setBroken] = useState(false);

  if (broken || !src) {
    return (
      <div
        className={`flex items-center justify-center ${fallbackClassName} ${className}`}
        data-testid={testId}
        role="img"
        aria-label={alt}
      >
        {fallback}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`object-cover ${className}`}
      onError={() => setBroken(true)}
      data-testid={testId}
    />
  );
}
